import { render, staticRenderFns } from "./payment-update.vue?vue&type=template&id=475355c6&scoped=true&"
import script from "./payment-update.vue?vue&type=script&lang=js&"
export * from "./payment-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475355c6",
  null
  
)

export default component.exports